<template>
  <section class="login">
    <app-loading :isFull="false" v-if="isLoading"/>
    <div class="mw-100">
      <div class="row">
        <div class="col-md-12">
          <div class="wrapper-form">
            <div class="subject">
              <h3>{{$t('msg.welcome')}}</h3>
            </div>
            <form
              class="row flex-row-reverse"
              v-show="panel == 'login'"
              @submit.prevent
              data-vv-scope="FormLogin"
            >
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="username"
                    :class="{active:form.username != ''}"
                    v-model="form.username"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.username')}} یا {{ $t('label.email')}} </label>
                  <span
                    v-if="errors.has('FormLogin.username')"
                    class="is-danger"
                  >{{$t('message.require.error.username')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="password"
                    v-validate="{ required: true, regex: /^(?=.*\d).{8,}$/ }"
                    name="password"
                    :class="{active:form.password != ''}"
                    v-model="form.password"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.password')}}</label>
                  <span
                    v-if="errors.has('FormLogin.password')"
                    class="is-danger"
                  >{{$t('message.require.error.password')}}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-action form-action-left">
                  <button
                    @click="login(form,'FormLogin')"
                    class="text-center bttn-material-flat bttn bttn-success margin-20"
                    v-ripple
                  >{{ $t('button.login') }}</button>
                  <button
                    @click="panel = 'register'"
                    class="text-center bttn-material-flat bttn bttn-gray margin-20"
                    v-ripple
                  >{{ $t('button.signIn') }}</button>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-action form-action-right my-3">
                  <button
                  tabindex="6"
                    @click="panel = 'forgetpasword'"
                    class="bttn-minimal font-12 bttn bttn-primary margin-20"
                    v-ripple
                  >رمز عبور خود را فراموش کرده ام</button>
                  <button
                    @click="panel = 'newPasword'"
                    class="bttn-minimal font-12 bttn bttn-success margin-20"
                    v-ripple
                  >کد را دریافت کرده ام</button>
                </div>
              </div>

            </form>

            <form
              class="row flex-row-reverse"
              v-show="panel == 'forgetpasword'"
              @submit.prevent
              data-vv-scope="FormForget"
            >
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="text"
                    name="email"
                    :class="{active:form.email != ''}"
                    v-model="form.email"
                    v-validate="'required'"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.email')}}</label>
                  <span
                    v-if="errors.has('FormForget.email')"
                    class="is-danger"
                  >{{$t('message.require.error.email')}}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-action form-action-left">
                    <button
                    @click="forget(form.email,'FormForget')"
                    class="text-center bttn-material-flat bttn bttn-primary margin-20"
                    v-ripple
                  >ارسال</button>
                  <button
                    @click="panel = 'login'"
                    class="text-center bttn-minimal bttn bttn-success margin-20"
                    v-ripple
                  >به خاطر آوردم</button>

                </div>
              </div>
            </form>

            <form
              class="row flex-row-reverse"
              v-show="panel == 'newPasword'"
              @submit.prevent
              data-vv-scope="FormNewPasword"
            >
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="text"
                    name="email"
                    :class="{active:form.code != ''}"
                    v-model="form.code"
                    v-validate="'required'"
                  >
                  <span class="bar"></span>
                  <label>کد ارسالی</label>
                  <span
                    v-if="errors.has('FormNewPasword.code')"
                    class="is-danger"
                  >فیلد کد نباید خالی باشد</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="text"
                    name="email"
                    :class="{active:form.email != ''}"
                    v-model="form.email"
                    v-validate="'required'"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.email')}}</label>
                  <span
                    v-if="errors.has('FormNewPasword.email')"
                    class="is-danger"
                  >{{$t('message.require.error.email')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    v-validate="{ required: true, regex: /^(?=.*\d).{8,}$/ }"
                    name="password"
                    type="password"
                    :class="{active:form.password != ''}"
                    v-model="form.password"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.password')}}</label>
                  <span
                    v-if="errors.has('FormNewPasword.password')"
                    class="is-danger"
                  >{{$t('message.require.error.password')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    v-validate="'required|confirmed:password'"
                    data-vv-as="password"
                    name="re_password"
                    type="password"
                    :class="{active:form.re_password != ''}"
                    v-model="form.re_password"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.re_password')}}</label>
                  <span
                    v-if="errors.has('FormRegister.re_password')"
                    class="is-danger"
                  >{{$t('message.require.error.re_password')}}</span>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-action form-action-left">
                  <button
                    @click="panel = 'login'"
                    class="text-center bttn-minimal bttn bttn-success margin-20"
                    v-ripple
                  >به خاطر آوردم</button>
                  <button
                    @click="submitPassword(form.email,'FormForget')"
                    class="text-center bttn-material-flat bttn bttn-primary margin-20"
                    v-ripple
                  >ذخیره پسورد</button>
                </div>
              </div>
            </form>

            <form
              class="row flex-row-reverse"
              v-show="panel == 'register'"
              @submit.prevent
              data-vv-scope="FormRegister"
            >
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="text"
                    name="fullname"
                    :class="{active:form.fullname != ''}"
                    v-model="form.fullname"
                    v-validate="'required'"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.fullname')}}</label>
                  <span
                    v-if="errors.has('FormRegister.fullname')"
                    class="is-danger"
                  >{{$t('message.require.error.fullname')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    type="text"
                    v-validate="'required'"
                    name="username"
                    :class="{active:form.username != ''}"
                    v-model="form.username"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.username')}}</label>
                  <span
                    v-if="errors.has('FormRegister.username')"
                    class="is-danger"
                  >{{$t('message.require.error.username')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    v-validate="'required|email'"
                    type="text"
                    name="email"
                    :class="{active:form.email != ''}"
                    v-model="form.email"
                  >
                  <span class="bar"></span>
                  <label>{{$t('label.email')}}</label>
                  <span
                    v-if="errors.has('FormRegister.email')"
                    class="is-danger"
                  >{{$t('message.require.error.email')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    v-validate="{ required: true, regex: /^(?=.*\d).{8,}$/ }"
                    name="password"
                    type="password"
                    :class="{active:form.password != ''}"
                    v-model="form.password"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.password')}}</label>
                  <span
                    v-if="errors.has('FormRegister.password')"
                    class="is-danger"
                  >{{$t('message.require.error.password')}}</span>
                </div>
              </div>
              <div class="col-lg-12 col-12">
                <div class="group-form">
                  <input
                    v-validate="'required|confirmed:password'"
                    data-vv-as="password"
                    name="re_password"
                    type="password"
                    :class="{active:form.re_password != ''}"
                    v-model="form.re_password"
                  >
                  <span class="bar"></span>
                  <label>{{ $t('label.re_password')}}</label>
                  <span
                    v-if="errors.has('FormRegister.re_password')"
                    class="is-danger"
                  >{{$t('message.require.error.re_password')}}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="false">
                <div class="group-form-checkbox">
                  <div class="label-form">
                    <label>{{ $t('label.sex')}}</label>
                  </div>
                  <div class="md-radio inline">
                    <input id="0" type="radio" value="0" name="sex" v-model="form.sex">
                    <label for="0">{{ $t('label.male')}}</label>
                  </div>
                  <div class="md-radio inline">
                    <input id="1" type="radio" value="1" name="sex" v-model="form.sex">
                    <label for="1">{{ $t('label.female')}}</label>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-action form-action-left">
                  <div class="input-checkbox rtl text-right">
                    <div class="md-checkbox">
                      <input type="checkbox" id="news" checked="true" disabled>
                      <label for="news" class="font-14">
                        با
                        <router-link target="_blank"
                                     to="/v1/terms-of-use">
                            قوانین
                        </router-link>سایت موافقم
                      </label>
                    </div>
                  </div>
                  <div class="input-checkbox rtl text-right">
                    <div class="md-checkbox">
                      <input type="checkbox" id="news" checked="true" disabled>
                      <label for="news" class="font-14">اطلاع از آخرین دوره ها و تخفیف ها</label>
                    </div>
                  </div>


                  <button
                    @click="register(form,'FormRegister')"
                    class="bttn-material-flat bttn bttn-royal margin-20"
                    v-ripple
                  >{{ $t('button.signIn') }}</button>
                  <button
                    @click="panel = 'login'"
                    class="bttn-material-flat bttn bttn-gray margin-20"
                    v-ripple
                  >{{ $t('button.imUser') }}</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// TODO login witout activeate email ....
var vm;
export default {
  data() {
    return {
      isLoading: false,
      isUser: true,
      panel: "login",
      form: {
        fullname: "",
        username: "",
        email: "",
        password: "",
        code: "",
        re_password: "",
        sex: ""
      }
    };
  },
  mounted() {
    vm = this;
  },
  computed: {
    isRedirect() {
      return this.$store.state.auth.isRedirect;
    }
  },
  destroyed() {
    this.clearForm();
    this.$store.commit("auth/setRedirect", true);
  },
  methods: {
    clearForm() {
      this.form = {
        fullname: "",
        username: "",
        email: "",
        password: "",
        code: "",
        re_password: "",
        sex: ""
      };
      this.$validator.reset();
    },
    async login(data, scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      let res = await this.$store.dispatch("auth/login", data);
      await this.handelStateLogin(res);
      this.isLoading = false;
      if (this.$route.query && this.$route.query.callBackUrl) {
        this.handelCallBackUrl();
      }
       else if (this.$route.query && this.$route.query.callback) {
         window.location.replace(this.$route.query.callback)
       }
       else {
        if (this.isRedirect) {
          this.$router.push("/dashboard/profile");
        } else {
          this.$store.dispatch("auth/showModalLogin", false);
          this.$store.commit("auth/setRedirect", true);
        }
      }
    },
    handelStateLogin(res) {
      this.$store.dispatch("auth/showModalLogin", false);
      if (res.state !== 200) {
        if (res.state === 404) {
          this.$root.showWarnMsg({
            message: "نام کاربری یا گذر واژه مشکل دارد ..."
          });
        }
        if (res.state === 406) {
          this.$root.showWarnMsg({
            message: "حساب کاربری شما غیرفعال شده است ..."
          });
        }
      }
    },
    handelCallBackUrl() {
      if (this.$route.query.setFavorit) {
        this.$store.dispatch(
          "courses/addToFavorite",
          this.$route.query.setFavorit
        );
      }
      if (this.$route.query.startEnroll) {
        this.$store.dispatch("courses/startEnroll", {
          id: this.$route.query.startEnroll
        });
      }
      this.$router.push(this.$route.query.callBackUrl);
    },
    async submitPassword(data, scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      let res = await this.$store.dispatch("auth/submitPassword", this.form);
      if (res.state === 200) return;
      this.$root.showSuccessMsg({
        message: "رمز عبور با موفقیت بروزرسانی شد"
      });
      this.$root.showSuccessMsg({
        message: "با رمز جدید وارد شوید"
      });
      this.panel = "login";
      this.isLoading = false;
    },
    async forget(item, scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.isLoading = true;
      const { data } = await this.$store.dispatch("auth/forget", {
        email: item
      });
      if (data.state !== 200) {
        if (data.message === "NotFound") {
          this.$root.showWarnMsg({
            message: "ایمیل در سیستم موجود نیست..."
          });
        }
        this.isLoading = false;
        return;
      }
      this.$root.showSuccessMsg({
        message: "کد رمز عبور برای شما ارسال شد"
      });
      this.panel = "newPasword";
      this.isLoading = false;
    },
    postEmail(email) {
      this.$store.dispatch("newsLatter", { email: email, group: "10939494" });
    },
    async register(data, scope) {
      let result = await this.$validator.validateAll(scope);
      if (!result) {
        this.$root.showWarnMsg({
          message: "لطفا فرم را تکمیل کنید ... "
        });
        return;
      }
      this.postEmail(this.form.email);
      this.isLoading = true;
      let res = await this.$store.dispatch("auth/register", data);
      if (res.state === 200) this.login(this.form, "FormLogin");
      // this.clearForm();
      this.isLoading = false;
    }
  }
};
</script>

<style lang="less">
.login {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue